import { api, API } from "@/lib/api";

// Registers a short-lived narration job (JWT-authed) and returns a streaming
// audio URL the browser can play progressively via a plain <audio>/Audio src.
// ElevenLabs streams the clip with low time-to-first-byte; the backend caches it
// so an identical replay is instant.
export async function narrateUrl(text, voice) {
  const { data } = await api.post("/voice/narrate", { text, voice });
  return `${API}/voice/stream/${data.nid}`;
}
